exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidenav.administration {\n  max-width: 250px;\n  min-width: 200px;\n  width: 15%; }\n  .sidenav.administration .nav-list {\n    margin-top: 20px; }\n    .sidenav.administration .nav-list .nav-link {\n      padding-bottom: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/administration-main/administration.scss
// module id = FZz6
// module chunks = 0